module.exports = __webpack_public_path__ + "media/notification_sound.893d1915.wav";